import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=5d2e6a1a&"
import script from "./SystemMessages.vue?vue&type=script&lang=js&"
export * from "./SystemMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports